import styled from 'styled-components'

export const TextArea = styled.textarea`
  width: 100%;
  background-color: #f7f7f7;
  opacity: 0.9;
  padding: 1em;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ContainerButton = styled.div`
  margin-top: 1em;
  display: flex;
`
